import { Bar, Doughnut, Line } from "react-chartjs-2";

import { getColor } from "@/utils";

import { BaseWidget } from "./BaseWidget";
import {
  barOptions,
  eventPropsForPie,
  eventPropsForTimeline,
  lineOptions,
  pieOptions,
} from "./chart_options";
import {
  getLabelsAndDatasetsGroupedByMediaType,
  showOneDecimalPlace,
  sumArray,
} from "./helpers";

const hasData = (data) =>
  data &&
  data.map((d) => (d.statsPerDateAndSource || []).length).reduce(sumArray, 0) >
    0;

const MediaTypesLineWidget = (props) => {
  const isStacked = props.chartType === "area_stacked";

  const chartData = getLabelsAndDatasetsGroupedByMediaType(
    "statsPerDateAndSource",
    hasData(props.data) ? props.data : null,
    isStacked
  );

  const options = lineOptions(isStacked, props.size);

  return (
    <BaseWidget {...props} hasData={hasData(props.data)}>
      <Line
        data={chartData}
        options={{
          ...options,
          ...eventPropsForTimeline(chartData, props, "mediaType"),
        }}
      />
    </BaseWidget>
  );
};

const MediaTypesBarWidget = (props) => {
  const chartData = getLabelsAndDatasetsGroupedByMediaType(
    "statsPerDateAndSource",
    hasData(props.data) ? props.data : null
  );

  const options = barOptions(true, props.size);

  return (
    <BaseWidget {...props} hasData={hasData(props.data)}>
      <Bar
        data={chartData}
        options={{
          ...options,
          ...eventPropsForTimeline(chartData, props, "mediaType"),
        }}
      />
    </BaseWidget>
  );
};

const MediaTypesPieWidget = (props) => {
  const KEY = "statsPerDateAndSource";

  let datasets = [],
    labels = [],
    backgroundColors = [];

  if (hasData(props.data)) {
    const allSources = {};

    props.data.forEach((entry) => {
      const amounts = entry[KEY];
      amounts.forEach(([, sourcesAndCounts]) => {
        Object.entries(sourcesAndCounts).forEach(([source, count]) => {
          if (!allSources[source]) allSources[source] = 0;
          allSources[source] += count;
        });
      });
    });

    const total = Object.values(allSources).reduce(sumArray, 0);

    Object.entries(allSources).forEach(([source, count], i) => {
      labels.push(source);
      datasets.push(showOneDecimalPlace(count, total));
      backgroundColors.push(getColor(i, { title: source, scope: "mediaType" }));
    });

    datasets = [
      {
        data: datasets,
        backgroundColor: backgroundColors,
        hoverBackgroundColor: backgroundColors,
      },
    ];
  }

  const chartData = { labels, datasets };
  const options = pieOptions();

  return (
    <BaseWidget {...props} hasData={hasData(props.data)}>
      <Doughnut
        data={chartData}
        options={{
          ...options,
          ...eventPropsForPie(chartData, props, "mediaType"),
        }}
      />
    </BaseWidget>
  );
};

const MediaTypesWidget = (props) => {
  return props.chartType == "pie" ? (
    <MediaTypesPieWidget {...props} />
  ) : props.chartType == "bar" ? (
    <MediaTypesBarWidget {...props} />
  ) : (
    <MediaTypesLineWidget {...props} />
  );
};

export { MediaTypesWidget };
